import { FETCH_AUTH_INFO } from "@/store/action-types"
const can = async(permission, store) => {


    await store.dispatch(FETCH_AUTH_INFO)

    const permissions = store.state.auth.authUser.permissions;
    return permissions.includes(permission) || permissions.includes('do_all')
}

export default can